import { sdkRequest, translateServerErrors } from '@eventbrite/http';
import { ACCOUNT_STATUS_ERROR_SPEC } from '../constants/lookupMessages';

export const LOOKUP_URL = '/api/v3/users/lookup/';
export const LOGIN_WITH_TOKEN_URL = '/auth/provision_from_token/';

export interface ILookUpUserApiQueryProps {
    email: string;
    socialProvider?: string;
    sub?: string;
}

export interface ILookUpUserApiResponseProps {
    canLogin: boolean;
    exists: boolean;
    isEmailVerified: boolean;
    signInMethods: string[]; // examples: ['password', 'google_login']
    userId: string;
}

interface ILookUpUserApiRawResponseProps {
    can_login: boolean;
    exists: boolean;
    is_email_verified: boolean;
    sign_in_methods: string[];
    user_id: string;
}

export const lookUpUser = ({
    email,
    socialProvider = '',
    sub = '',
}: ILookUpUserApiQueryProps) =>
    sdkRequest(LOOKUP_URL, {
        method: 'POST',
        body: JSON.stringify({
            email,
            source_user_id: sub,
            source_provider: socialProvider,
        }),
    })
        .then((response: ILookUpUserApiRawResponseProps) => {
            const parsedResponse: ILookUpUserApiResponseProps = {
                canLogin: response['can_login'],
                exists: response.exists,
                isEmailVerified: response['is_email_verified'],
                signInMethods: response['sign_in_methods'],
                userId: response['user_id'],
            };

            // Return the response or an empty object to prevent failures
            return parsedResponse;
        })
        .catch(translateServerErrors(ACCOUNT_STATUS_ERROR_SPEC));
